module.exports = __webpack_public_path__ + "static/media/matilde-cap-sri-lanka-tired.a6f9bb5d.png";